import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const PartnerApprovalModal = ({ data, isOpen, toggle, onConfirm, status, isPub }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Change Application Status</ModalHeader>
      <ModalBody>
        Are you sure you want to{" "}
        
          <span
            className={
              status == "active" || status === true ? `text-primary text-capitalize` : `text-success text-capitalize`
            }
          >
            {status == "active" || status === true ? "Reject " : "Approve "}
          </span>
        
        this?
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color={
            status === "active" || status === true
              ? "primary"
              : status === "inactive" || status === false || status == "Inactive"
              ? "success"
              : "danger"
          }
          onClick={onConfirm}
        >
          Yes,{" "}
          { 
             status == "active" || status === true
            ? "Reject"
            : "Approve"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PartnerApprovalModal;